import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { X, Gift } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";

const LS_KEY = "welcome_popup_dismissed_v1";
const DISMISS_DAYS = 7;

export default function WelcomePopup() {
  const { user } = useAuth();
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (user) return; // tik neprisijungusiems
    try {
      const dismissed = localStorage.getItem(LS_KEY);
      if (dismissed && Date.now() - Number(dismissed) < DISMISS_DAYS * 864e5) return;
    } catch {}
    const t = setTimeout(() => setShow(true), 4000);
    return () => clearTimeout(t);
  }, [user]);

  const dismiss = () => {
    setShow(false);
    try { localStorage.setItem(LS_KEY, String(Date.now())); } catch {}
  };

  if (!show || user) return null;

  return (
    <div className="fixed inset-0 z-[70] flex items-end sm:items-center justify-center bg-black/50 p-3 sm:p-4" onClick={dismiss} data-testid="welcome-popup">
      <div
        className="relative w-full max-w-md bg-white dark:bg-[#0E1622] border border-gray-200 dark:border-gray-700 p-6 sm:p-8"
        onClick={(e) => e.stopPropagation()}
      >
        <button onClick={dismiss} className="absolute top-3 right-3 text-gray-400 hover:text-gray-700 dark:hover:text-white" aria-label="Uždaryti" data-testid="welcome-popup-close">
          <X size={18} />
        </button>
        <div className="flex items-center gap-3 mb-4">
          <div className="w-11 h-11 flex items-center justify-center bg-[#E6F7FC] dark:bg-[#0A2A38] text-[#00B5E2]">
            <Gift size={22} />
          </div>
          <div className="label-mono">Naujiems klientams</div>
        </div>
        <h3 className="font-heading text-2xl font-bold text-gray-900 dark:text-gray-100 leading-tight">
          Gauk <span className="text-[#00B5E2]">5 € nuolaidą</span> pirmam pirkiniui
        </h3>
        <p className="text-sm text-gray-500 dark:text-gray-400 mt-2">
          Užsiregistruok ir gauk asmeninį 5 € nuolaidos kodą užsakymui nuo 55 €. Kodas galioja 30 dienų.
        </p>
        <Link to="/registruotis" onClick={dismiss} className="btn-primary w-full justify-center mt-5" data-testid="welcome-popup-cta">
          Registruotis ir gauti kodą
        </Link>
        <button onClick={dismiss} className="w-full text-center text-xs text-gray-400 hover:text-gray-600 dark:hover:text-gray-300 mt-3">
          Ne, ačiū
        </button>
      </div>
    </div>
  );
}
